// import { AuthenticationReducer } from "./authentication/AuthenticationSlice";
import { AuthUserInfoReducer } from './authUserInfo/AuthUserInfoSlice';
import { CategoriesReducer } from './categories/CategoriesSlice';
import { InvitedPostsReducer } from './invitedPosts/InvitedPostsSlice';
import { InvitePeopleReducer } from './invitePeople/invitePeopleSlice';
import { LogoutReducer } from './logout/LogoutSlice';
import { NotificationsPostsReducer } from './notifications/NotificationsSlice';
import { PendingPostsReducer } from './pendingPosts/PendingPostsSlice';
import { PostReducer } from './post/PostSlice';
import { PublishedPostsReducer } from './publishedPosts/PublishedPostsSlice';
import { UnsubscribedUsersReducer } from './unsubscribedUsers/UnsubscribedUsersSlice';

const reducer = {
    invitePeople: InvitePeopleReducer,
    invitedPosts: InvitedPostsReducer,
    publishedPosts: PublishedPostsReducer,
    pendingPosts: PendingPostsReducer,
    notifications: NotificationsPostsReducer,
    categories: CategoriesReducer,
    post: PostReducer,
    authUserInfo: AuthUserInfoReducer,
    unsubscribedUsers: UnsubscribedUsersReducer,
    logout: LogoutReducer,
};

export default reducer;
